import { PromoNurseryModel } from "./promonursery.model";
import { PromoProductModel } from "./promoproduct.model";

export class PromotionModel {
    public uuid: string;
    public title: string;
    public description: string;
    public featured: boolean;
    public products: PromoProductModel[];
    public nurseries: PromoNurseryModel[];
    public mediaURL: string;

    constructor(value: JSON) {
        this.uuid = value["uuid"];
        this.title = value["title"];
        this.description = value["description"];
        this.featured = value["featured"];
        if(value["products"]) {
            this.products = [];
            for(const product of value["products"]) {
                this.products.push(new PromoProductModel(product));
            }
        }
        if(value["nurseries"]) {
            this.nurseries = [];
            for(const nursery of value["nurseries"]) {
                this.nurseries.push(new PromoNurseryModel(nursery));
            }
        }
    }
}